export default __webpack_public_path__ + "static/media/folder.c88013d2.svg";